import { FC } from 'react';
import _ from 'lodash';
import {
  Box,
  RadioGroup,
  RadioGroupProps,
  Text,
  TextProps,
} from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials-standalone/i18n';

export const dataHooks = {
  container: 'controlled-radio-group-container',
  radioGroup: 'controlled-radio-group',
};
interface IControlledRadioGroupProps {
  selected?: string;
  onChange: (x: any) => void;
  items: Record<string, string>;
  langTokenPrefix: string;
  spacing?: RadioGroupProps['spacing'];
  textSize?: TextProps['size'];
}

export const ControlledRadioGroup: FC<IControlledRadioGroupProps> = ({
  selected,
  onChange,
  items,
  langTokenPrefix,
  spacing,
  textSize,
}) => {
  const { t } = useTranslation();
  return (
    <Box direction="vertical" dataHook={dataHooks.container}>
      <RadioGroup
        value={selected}
        onChange={(val: string | number | undefined) => {
          onChange(val as keyof typeof items);
        }}
        spacing={spacing}
        dataHook={dataHooks.radioGroup}
      >
        {_.map(items, (item, index) => (
          <RadioGroup.Radio key={index} value={item}>
            <Text size={textSize}>{t(`${langTokenPrefix}${item}`)}</Text>
          </RadioGroup.Radio>
        ))}
      </RadioGroup>
    </Box>
  );
};

export default ControlledRadioGroup;
